module.exports = __webpack_public_path__ + "b63bac02dd82a3efcc94d94adadffdc3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ecomm2.png
// module id = 783
// module chunks = 0